import { Modal, ModalProps } from "antd";
import React, { ReactNode } from "react";
import style from "./style.module.scss";

interface ModalPropss extends ModalProps {
  children: ReactNode;
  open: boolean;
  confirmLoading?: boolean;
  handleOk?: () => void;
  handleCancel?: () => void;
  width?: number;
  okText?: string;
  cancelText?: string;
}

const CustomModal: React.FC<ModalPropss> = ({
  children,
  open,
  handleOk,
  confirmLoading,
  handleCancel,
  width = 500,
  okText = "Ok",
  cancelText = "Cancel",
  closable=false,
  ...props
}) => {
  return (
    <div>
      <Modal
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        width={width}
        okText={okText}
        cancelText={cancelText}
        closable={closable}
        okButtonProps={{ className: `${style.okBtn}` }}
        cancelButtonProps={{ className: `${style.cancelBtn}` }}
        {...props}
        centered
      >
        {children}
      </Modal>
    </div>
  );
};

export default CustomModal;
